export const iconFontAwesomePhotosImagesCircleHalfStroke = (
	<i className="fa-solid fa-circle-half-stroke"></i>
);
